import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import { LogotypeColorImg, VariousEnding } from 'public/assets';

const ShareContent = () => {
  const { t } = useTranslation();
  return (
    <div css={container}>
      <div className="background-gradient"></div>
      <section className="section-container">
        <div className="logo-wrapper">
          <LogotypeColorImg />
        </div>
        <p className="title">
          {t('share_screen_description_interactive_more_funny_than_novel')}
        </p>
        <p className="content">
          {t('share_screen_description_become_protagonist_of_story')}
        </p>
      </section>

      <div className="various-background"></div>

      <section className="section-container">
        <p className="bold-title">
          {t('share_screen_description_well_made_interactive_story')}
        </p>

        <p className="content">
          <strong>
            {t('share_screen_description_interactive_more_funny_than_novel')}
          </strong>
          {t('share_screen_description_hellobot_and_storyplay')}
        </p>
        <VariousEnding className="various-ending" width={500} height={300} />
      </section>
    </div>
  );
};

const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1.25em 0;
  position: relative;
  white-space: pre-line;

  .background-gradient {
    position: absolute;
    width: 800px;
    height: 15em;
    background-image: linear-gradient(
      to bottom,
      #f3e8ff,
      rgba(243, 232, 255, 0)
    );
    z-index: 0;

    @media screen and (max-width: ${theme.devices.mobile}) {
      width: 100%;
    }
  }

  .various-background {
    position: absolute;
    left: 0;
    top: 30%;
    height: 275px;
    width: 141px;
    border-top-right-radius: 141px;
    border-bottom-right-radius: 141px;
    background-image: linear-gradient(
      to bottom,
      rgba(44, 204, 211, 0.15),
      rgba(44, 204, 211, 0)
    );
    z-index: 0;
  }

  .logo-wrapper {
    min-height: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2em;
  }

  .title {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: -0.8px;
    color: ${theme.colors.primary500};
    margin-bottom: 1.25em;
    text-align: center;
  }

  .content {
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: -0.4px;
    color: ${theme.colors.gray600};
    text-align: center;
  }

  .bold-title {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: -0.8px;
    text-align: center;
    margin-top: 1em;
  }

  .section-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1em;
    margin: 2.25em 0;
    z-index: 1;
  }

  .various-ending {
    margin-top: 1.25em;
    height: 22em;
    width: 100%;

    @media screen and (max-width: ${theme.devices.mobile}) {
      height: 12em;
    }
  }
`;

export default ShareContent;
